var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',_vm._b({on:{"change":_vm.handleChange},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}},'el-date-picker',_vm.myProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }